"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/icon/style");
var _icon = _interopRequireDefault(require("antd/lib/icon"));
var _react = _interopRequireDefault(require("react"));
var _reactCopyToClipboard = require("react-copy-to-clipboard");
var _reactShare = require("react-share");
var _components = require("../../components");
var _utils = require("../../utils");
require("./ShareModal.less");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var ShareModal = function ShareModal(_ref) {
  var onClose = _ref.onClose,
    modalVisible = _ref.modalVisible,
    description = _ref.description,
    shareUrl = _ref.shareUrl,
    title = _ref.title;
  var handleCopy = function handleCopy() {
    _utils.toast.success({
      title: 'Link Copied!'
    });
  };
  var _useCssMedia = (0, _utils.useCssMedia)(),
    md = _useCssMedia.md;
  return /*#__PURE__*/_react.default.createElement(_components.Modal, {
    onClose: onClose,
    onCancel: onClose,
    centered: true,
    visible: modalVisible,
    footer: null,
    maskClosable: true,
    destroyOnClose: true,
    wrapClassName: (0, _classnames.default)({
      'share-modal': !md
    })
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "mt-[20px] tw-label-light text-black md:tw-subtitle-sm-light w-[80%] text-center md:w-[90%]"
  }, "Share this support group on any of the following social media:"), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex w-full justify-center pt-[25px] pb-[10px]"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex justify-between items-center w-full md:w-3/4"
  }, /*#__PURE__*/_react.default.createElement(_reactShare.EmailShareButton, {
    className: "share-button",
    url: shareUrl,
    subject: title,
    body: description
  }, /*#__PURE__*/_react.default.createElement(_reactShare.EmailIcon, {
    size: 32
  })), /*#__PURE__*/_react.default.createElement(_reactShare.WhatsappShareButton, {
    className: "share-button",
    url: shareUrl,
    title: title
  }, /*#__PURE__*/_react.default.createElement(_reactShare.WhatsappIcon, {
    size: 32
  })), /*#__PURE__*/_react.default.createElement(_reactShare.TelegramShareButton, {
    className: "share-button",
    url: shareUrl,
    title: title
  }, /*#__PURE__*/_react.default.createElement(_reactShare.TelegramIcon, {
    size: 32
  })), /*#__PURE__*/_react.default.createElement(_reactShare.FacebookShareButton, {
    className: "share-button",
    url: shareUrl,
    quote: description
  }, /*#__PURE__*/_react.default.createElement(_reactShare.FacebookIcon, {
    size: 32
  })), /*#__PURE__*/_react.default.createElement(_reactShare.FacebookMessengerShareButton, {
    className: "share-button",
    url: shareUrl,
    appId: process.env.REACT_APP_FACEBOOK_APP_ID
  }, /*#__PURE__*/_react.default.createElement(_reactShare.FacebookMessengerIcon, {
    size: 32
  })), /*#__PURE__*/_react.default.createElement(_reactCopyToClipboard.CopyToClipboard, {
    text: shareUrl,
    className: "mb-[8px]",
    onCopy: handleCopy
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    type: "link",
    size: "large",
    style: {
      fontSize: '32px'
    }
  }))))));
};
var _default = ShareModal;
exports.default = _default;